/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnrollConnectPaymentRedirectDto } from './EnrollConnectPaymentRedirectDto';

export type CarrierPaymentDto = {
  channel: CarrierPaymentDto.channel;
  redirect?: EnrollConnectPaymentRedirectDto;
  phoneNumber?: string;
};
export namespace CarrierPaymentDto {
  export enum channel {
    REDIRECT = 'REDIRECT',
    PHONE = 'PHONE',
    IN_FLOW_PAYMENT_METHOD = 'IN_FLOW_PAYMENT_METHOD',
  }
}
